import { createClientNavigator } from 'navigation/clientNavigator';
import { activatePageArea, deactivatePageArea, preparePageContent } from 'navigation/pageArea';
import { localizePageUrl } from 'i18n/urlLocale';

// The site's one client navigator (navigation/clientNavigator). Created on first
// use, so a component the ssr service renders can import this.
let navigator = null;

function siteNavigator() {
	if(!navigator) {
		navigator = createClientNavigator({
			window,
			document,
			fetchPage: (url, init) => window.fetch(url, {
				...init,
				credentials: 'same-origin',
				headers: { 'X-Smashladder-Navigation': '1', Accept: 'application/json' },
			}),
			activatePageArea,
			deactivatePageArea,
			preparePageContent,
			localizeUrl: (url) => localizePageUrl(url, window),
		});
	}
	return navigator;
}

export function startClientNavigation() {
	return siteNavigator().start();
}

// Opens url as a click on a link to it would: in place on a navigable page,
// otherwise with a full load.
export function visit(url) {
	return siteNavigator().visit(url);
}

export function claimLocations(claim) {
	return siteNavigator().claimLocations(claim);
}
